import { SET_DATA, SET_ERRORS, LOADING_DATA, LOADING_EMPRESA, SET_EMPRESA, SET_PONTO } from "../types";
import api from "../../services/api";

export function getApiData(resource, param = null) {
  return function action(dispatch) {
    dispatch({ type: LOADING_DATA });

    if (!resource) {
      console.error("resource não informado");
      dispatch({
        type: SET_ERRORS,
        payload: "resource não informado",
      });
    }

    let URL = `/${resource}`;
    if (param) {
      URL = URL + `/${param}`;
    }
    return api
      .get(URL)
      .then((res) => {
        console.log(res.data);
        dispatch({
          type: SET_DATA,
          payload: res.data,
        });
      })
      .catch((err) => {
        console.error(err);
        dispatch({
          type: SET_ERRORS,
          payload: err.response.data,
        });
      });
  };
}

export const getIdEmpresa = () => (dispatch) => {
  dispatch({ type: LOADING_EMPRESA });
  console.log("Obtendo idEmpresa salvo do sessionStorage");
  const jsonString = sessionStorage.CompanyId;
  try {
    const data = JSON.parse(jsonString)
    console.log("JSON CompanyId", data);
    api.defaults.headers.CompanyId = `CompanyId ${data._idEmpresa}`
    dispatch({
      type: SET_EMPRESA,
      payload: {...data},
    });
  } catch (error) {
    console.error('Erro ao execurar JSON.parse')
    dispatch({
      type: SET_EMPRESA,
      payload: 'Teste',
    });
  }


  
};


export const putPonto = (data) => (dispatch) => {
  dispatch({ type: SET_PONTO ,payload:data });
};
